import { getDataTestId } from 'eone-ui/functions/data-test-ids';
import { Modal, ModalMessage } from 'eone-ui/modal/modal';
import { ModalButtonType } from 'eone-ui/modal/modal-constants';

export function SuccessModal(props) {
  const getFooterButtons = () => {
    return [
      {
        Label: props.ButtonLabel || 'OK',
        Type: props.ButtonType || ModalButtonType.Primary,
        Visible: true,
        OnClick: props.Close,
      },
    ];
  };
  return (
    <Modal
      Show={props.Show}
      Title={props.Title}
      Close={props.Close}
      FooterButtons={getFooterButtons()}
      DataTestId={props.DataTestId}
    >
      <ModalMessage
        Message={props.Message}
        DataTestId={getDataTestId(props.DataTestId, 'success-message')}
      />
    </Modal>
  );
}
